// @flow

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'slick-carousel/slick/slick.css';
import 'simplebar/dist/simplebar.css';

import {
    BrowserRouter
} from "react-router-dom";

import {Amplify} from "aws-amplify";

import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persister } from './store/index';

Amplify.configure({
    Auth: {
        identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        region: process.env.REACT_APP_REGION,
        userPoolId: process.env.REACT_APP_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEBCLIENT_ID,
           oauth: {
               domain: process.env.REACT_APP_COGNITO_DOMAIN,
               scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
               redirectSignIn: process.env.REACT_APP_redirectSignIn,
               redirectSignOut: process.env.REACT_APP_redirectSignOut,
               responseType: 'code',
           }
    },
    API: {
        endpoints: [
            {
                name: process.env.REACT_APP_ENDPOINT_NAME,
                endpoint: process.env.REACT_APP_ENDPOINT,
                region: 'ap-southeast-2'
            }
        ]
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persister}>
          <BrowserRouter>
                  <link
                      rel="stylesheet"
                      href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.0-beta1/dist/css/bootstrap.min.css"
                      integrity="sha384-0evHe/X+R7YkIZDRvuzKMRqM+OrBnVFBL6DOitfPri4tjfHxaWutUpFmBp4vmVor"
                      crossOrigin="anonymous"
                  />
                <App />
              </BrowserRouter>
        </PersistGate>
    </ReduxProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
